<script setup lang="ts">
import { ref, useTemplateRef, type HTMLAttributes } from 'vue'
import { useResizeObserver } from '@vueuse/core'

import { cn } from '@ds/lib/utils'

const SHRINK_THRESHOLD = 1024

type Props = {
  class?: HTMLAttributes['class']
}

const props = defineProps<Props>()

const headerRef = useTemplateRef('headerRef')

const isShrunk = ref(false)

useResizeObserver(headerRef, entries => {
  const entry = entries?.[0]
  if (!entry) return
  calculateIsShrunk(entry as ResizeObserverEntry)
})

const calculateIsShrunk = (entry: ResizeObserverEntry) => {
  isShrunk.value = entry.target.clientWidth < SHRINK_THRESHOLD
}
</script>

<template>
  <header
    ref="headerRef"
    :class="cn(
      'font-ds h-15 shrink-0 relative z-10',
      'flex items-center gap-4 pr-5 pl-4',
      'bg-card text-foreground border-b border-border',
      props.class,
    )"
  >
    <slot
      name="repository"
      :is-shrunk
    />
    <div
      v-if="!isShrunk"
      class="flex-1"
    />
    <slot
      name="search"
      :is-shrunk
    />
    <div
      v-if="$slots.actions"
      class="flex items-center gap-4 overflow-hidden"
    >
      <slot
        name="actions"
        :is-shrunk
      />
    </div>
  </header>
</template>
